module.exports = __webpack_public_path__ + "img/bul_component_image.1bcb0214.svg";